import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "wrapper-background"
};
const _hoisted_2 = {
  class: "g1g__cards_wrapper"
};
const _hoisted_3 = {
  class: "g1g__inlinecard"
};
const _hoisted_4 = {
  class: "inline__cards"
};
const _hoisted_5 = {
  class: "inline__card"
};
const _hoisted_6 = {
  class: "inline__card"
};
const _hoisted_7 = {
  class: "card__content card__content--left m-md-auto"
};
const _hoisted_8 = {
  class: "card_button mb-3"
};
const _hoisted_9 = {
  class: "inline__card"
};
const _hoisted_10 = {
  class: "card__content card__content--left"
};
const _hoisted_11 = {
  class: "card_button mb-3"
};
import { onMounted, ref, toRaw } from "vue";
import { useRouter } from "vue-router";
import { createNamespacedHelpers } from "vuex-composition-helpers";
import { itiraStates } from "@/composable/vuelidate";
import { track } from "@/analytics/events";
import CloudinaryImage from "@/components/CloudinaryImage.vue";
import { uuid } from "vue-uuid";
import Bugsnag from "@bugsnag/js";
export default {
  __name: 'inlineCard',
  setup(__props) {
    const itiraStore = createNamespacedHelpers("itira");
    const {
      itira
    } = itiraStore.useState(["itira"]);
    const userStore = createNamespacedHelpers("user");
    const {
      getCustomerInfo
    } = userStore.useGetters(["getCustomerInfo"]);
    const router = useRouter();
    const {
      useState,
      useActions
    } = createNamespacedHelpers("itira");
    const plansStore = createNamespacedHelpers("plans");
    const {
      resetItiraStore
    } = useActions(["resetItiraStore"]);
    const {
      deleteAllCartItems
    } = plansStore.useActions(["deleteAllCartItems"]);
    const trackPayload = {
      customer_info: toRaw(getCustomerInfo.value),
      cart_id: itira.value?.itira_uuid ?? null,
      event_id: uuid.v4(),
      event_name: "Itira Welcome"
    };
    const toIteraTravelReasons = () => {
      track("ITIRA - Start", {
        ...trackPayload
      });
      Bugsnag.leaveBreadcrumb('Button clicked');
      let {
        itira_uuid
      } = toRaw(itira.value);
      deleteAllCartItems(itira_uuid);
      itiraStates.value = [];
      resetItiraStore();
      router.push({
        path: "/itira/travel-reasons"
      });
      track(`Static Clickable`, {
        source: "Home page - Welcome ITIRA"
      });
    };
    const redirectTo = path => {
      if (path === "/about-us") {
        track(`Static Clickable`, {
          source: "Home page - The G1G story"
        });
      } else if (path === "blogs/with-you-when-it-matters-g1gs-commitment-to-you") {
        track(`Static Clickable`, {
          source: "Home page - Why G1G"
        });
      } else if (path === "how-g1g-works-best-travel-insurance") {
        track(`Static Clickable`, {
          source: "Home page - How G1G works"
        });
      }
      router.push({
        path
      });
    };
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
        class: "card__content card__content--left"
      }, [_cache[2] || (_cache[2] = _createElementVNode("h3", {
        class: "card__title"
      }, " Travel smarter. Travel safer. ", -1)), _cache[3] || (_cache[3] = _createElementVNode("p", {
        class: "sub__heading"
      }, " AI analyzes your trips. Constructs your perfect insurance package. ", -1)), _createElementVNode("div", {
        class: "card_button mb-3"
      }, [_createElementVNode("a", {
        class: "btn-outline-primary",
        onClick: toIteraTravelReasons
      }, "Check prices")])]), _createVNode(CloudinaryImage, {
        class: "card__img",
        imageName: "M3_fgh4v8",
        alt: "Illustration of a hand holding a smartphone with a G1G travel plan"
      })])]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_cache[6] || (_cache[6] = _createElementVNode("h3", {
        class: "card__title"
      }, " Built different. Built from experience. ", -1)), _cache[7] || (_cache[7] = _createElementVNode("p", {
        class: "sub__heading"
      }, " We've been burnt by insurance. Our mission: ensure it doesn't happen to you. ", -1)), _createElementVNode("div", _hoisted_8, [_cache[5] || (_cache[5] = _createElementVNode("a", {
        id: "film-button",
        class: "btn-primary mobile__btn",
        href: "https://youtu.be/p4FfExMhwqQ?si=y6Q0f-STE5mGHo8c",
        target: "_blank"
      }, "Watch the film", -1)), _createVNode(_component_router_link, {
        to: "/about-us",
        onClick: _cache[0] || (_cache[0] = $event => redirectTo('/about-us')),
        class: "btn-outline-primary"
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("Learn more")])),
        _: 1
      })])]), _createVNode(CloudinaryImage, {
        class: "card__img",
        imageName: "M2_bfh4kj",
        alt: "Illustration of a G1G travel expert holding a shield up for a traveler"
      })])]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_cache[8] || (_cache[8] = _createElementVNode("h3", {
        class: "card__title"
      }, "With you when it matters. Always.", -1)), _cache[9] || (_cache[9] = _createElementVNode("p", {
        class: "sub__heading for-special-devices"
      }, " Whole trip support. Real human help. Fast digital claims. 24/7. ", -1)), _createElementVNode("div", _hoisted_11, [_createElementVNode("a", {
        class: "btn-outline-primary",
        onClick: _cache[1] || (_cache[1] = $event => redirectTo('/blogs/with-you-when-it-matters-g1gs-commitment-to-you')),
        href: "javascript:void(0)"
      }, "Learn more")])]), _createVNode(CloudinaryImage, {
        class: "card__img",
        imageName: "unbiasedplan_sorsr4",
        alt: "Illustration of an adult skiier contacting G1G travel support for his child's injured leg"
      })])])])])])]);
    };
  }
};